import script from "./JaContentDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./JaContentDetail.vue?vue&type=script&setup=true&lang=js"

import "./JaContentDetail.vue?vue&type=style&index=0&id=59f61a42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59f61a42"]])

export default __exports__